// removed by extract-text-webpack-plugin
module.exports = {"ContactList":"_1SVHvEXn","Line":"CjPr_2Rr"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/imprint/imprint-page.styles.scss
// module id = 261
// module chunks = 0